import { render, staticRenderFns } from "./ProductDiscount.vue?vue&type=template&id=7bcf060e&scoped=true"
import script from "./ProductDiscount.vue?vue&type=script&lang=js"
export * from "./ProductDiscount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bcf060e",
  null
  
)

export default component.exports